<div class="modal-confirmacao-redesign flex-direction-column">
  <div class="modal-confirmacao-cabecalho flex-direction-row justify-between align-center">
    <span class="modal-confirmacao-titulo">{{ titulo }}</span>
    <button type="button" class="modal-confirmacao-fechar-x" title="Fechar" (click)="cancelar()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-confirmacao-linha"></div>

  <div class="modal-confirmacao-corpo">
    <span class="modal-confirmacao-texto">{{ texto }}</span>
  </div>

  <div class="modal-confirmacao-linha"></div>

  <div class="modal-confirmacao-rodape flex-direction-row justify-end gap-10">
    <button type="button" class="modal-confirmacao-btn-cancelar" (click)="cancelar()">{{ labelCancelar }}</button>
    <app-botao [label]="labelConfirmar" [icone]="''" largura="auto" (aoClicar)="confirmar()"></app-botao>
  </div>
</div>
